import styles from './index.module.less';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { capitalizeFirstLetter } from '@/lib/hooks/utils/utils';
import { useTranslation } from 'react-i18next';

const Index = ({ platList }: { platList: any }) => {
  const { t } = useTranslation();
  const router = useRouter();
  return (
    <ul className={styles.container}>
      {platList.map((item: any, index: number) => (
        <li
          key={item.platform}
          onClick={() => {
            router.push(`/compare/${item.platform}-alternatives`);
          }}
        >
          <div>
            <div className={styles.logoname}>
              <Image src={item.icon} alt={item.platform} width={20} height={20} priority={index > 1} />
              <h3>{capitalizeFirstLetter(t(item.platform))}</h3>
            </div>
            <div className={styles.visitor}>
              <span>{(item.visit_count / 1000000).toFixed(1)}M</span>
              <span>{(item.ratio * 100).toFixed(1)}%</span>
            </div>
          </div>
          <ul className={styles.featureList}>
            {item.features.map((feature: any) => (
              <li key={feature.id}>
                <div>{capitalizeFirstLetter(t(feature.name))}:</div>
                <div
                  dangerouslySetInnerHTML={{
                    __html: t(feature.value)
                      .replaceAll('\n', '<br/>')
                      .replace(/[\d$%.\-\/]+/g, '<span style="color: #428DFF;font-weight:bold;">$&</span>'), // 为数字添加颜色
                  }}
                ></div>
              </li>
            ))}
          </ul>
        </li>
      ))}
    </ul>
  );
};

export default Index;
